class ModalPresenter {
  removeVideo = () => {
    this.content.querySelector('#hotspot-video').src = '';
  };

  renderAppsInclude = () => {
    const appsRendered = this.content.querySelectorAll(
      '.hotspot-apps-included--app'
    );
    appsRendered.forEach(app => {
      app.remove();
    });
    const { included } = this.appInfo;
    const appsIncluded = [];
    Object.entries(included).forEach(([key, value]) => {
      if (value === true) {
        appsIncluded.push(key);
      }
    });
    appsIncluded.forEach(appName => {
      const app = this.settings[appName];
      const htmlTemplate = `
        <div class="hotspot-apps-included--app-logo">
          <img src="${app.logo}" alt="${appName} logo">
        </div>
        <div class="hotspot-apps-included--app-details">
          ${app.details}
        </div>
        <div class="hotspot-apps-included--app-price">
          ${app.price}
        </div>
        <div class="hotspot-apps-included--app-install">
          <a href="${app.link}" target="_blank">${app.linkText}</a>
        </div>
        `;
      const appList = document.createElement('div');
      appList.classList = 'hotspot-apps-included--app';
      appList.innerHTML = htmlTemplate;
      this.appsIncludedEl.append(appList);
    });
  };

  renderAppData = () => {
    const banner = this.content.querySelector('.modal-content-header--details-description');
    const title = this.content.querySelector('.modal-content-info--title');
    const description = this.content.querySelector(
      '.modal-content-info--description'
    );
    const link = this.content.querySelector('.modal-content-info--link a');
    const video = this.content.querySelector('#hotspot-video');
    if (
      !banner ||
      !title ||
      !description ||
      !link ||
      !video ||
      !this.appInfo.title ||
      !this.appInfo.description
    )
      return;
    banner.textContent = this.appInfo.banner;
    title.textContent = this.appInfo.title;
    description.innerHTML = this.appInfo.description;
    video.src = this.appInfo.video;
    if (this.appInfo.link) {
      link.href = this.appInfo.link;
    }
    this.renderAppsInclude();
  };

  // eslint-disable-next-line class-methods-use-this
  init(hotspot) {
    this.content = document.getElementById('bms-hotspot-modal-content');
    if (!this.content) return;

    this.appsIncludedEl = this.content.querySelector(
      '.modal-content-apps-used--apps'
    );
    if (!this.appsIncludedEl) return;

    this.settings = JSON.parse(
      document.getElementById('bms-hotspot-json').innerHTML
    );
    if (!this.settings) return;

    const hotspotObject = this.settings.hotspot;
    if (!hotspotObject) return;

    const obj = {};
    hotspotObject.forEach(item => {
      const key = Object.keys(item);
      const values = Object.values(item);
      obj[key] = values[0];
    });
    this.appInfo = obj[hotspot];
    this.renderAppData();
    document.addEventListener('modalClosed', this.removeVideo);
  }
}

export default ModalPresenter;
